import styled from '@emotion/styled';

const TableRow = styled('div')`
  display: table-row;
  width: 100%;
`;

export default TableRow;
